import i18n from 'i18next';
import { formatCurrency, formatCurrencyCode } from './currency';
// Stored on the i18next options object so it travels with the instance.
// Set post-auth via setDefaultCurrency(); read by the currency formatters as fallback.
function getDefaultCurrency() {
    return (i18n.options.defaultCurrency ?? 'USD');
}
/**
 * Sets the default currency used by the `currency` and `currencyCode` i18next formatters
 * when no currency is passed explicitly in the translation call.
 *
 * Call once post-auth when company data is available:
 *   setDefaultCurrency(company.currency);
 *
 * Individual t() calls can still override per-call:
 *   t('invoice_total', { amount, currency: invoice.currency })
 */
export function setDefaultCurrency(currency) {
    i18n.options.defaultCurrency = currency;
}
function truncateString(value, options = {}) {
    const { length = 30, omission = '...' } = options;
    if (value.length <= length) {
        return value;
    }
    const end = length - omission.length;
    if (end < 0) {
        return omission;
    }
    return value.slice(0, end) + omission;
}
/**
 * Registers custom i18next formatters on the shared instance.
 * Should be called once during i18n initialization.
 *
 * Formatters registered:
 *   truncate     — {{value, truncate}}
 *   currency     — {{amount, currency}}     → narrow symbol ($1,234.56)
 *   currencyCode — {{amount, currencyCode}} → ISO code   (USD 1,234.56)
 *
 * Both currency formatters fall back to the default set by setDefaultCurrency()
 * when no currency is passed in the template or t() options.
 * The current i18next locale is threaded through so number formatting is locale-aware.
 */
export function registerFormatters() {
    i18n.services.formatter.add('truncate', (value, _lng, options) => {
        return truncateString(value, options);
    });
    i18n.services.formatter.add('currency', (value, lng, options) => {
        return formatCurrency(value, {
            currency: options?.currency ?? getDefaultCurrency(),
            locale: lng ?? 'en-US'
        });
    });
    i18n.services.formatter.add('currencyCode', (value, lng, options) => {
        return formatCurrencyCode(value, {
            currency: options?.currency ?? getDefaultCurrency(),
            locale: lng ?? 'en-US'
        });
    });
}
//# sourceMappingURL=formatters.js.map